/**
 * Admin area bundle: the vendor libraries the admin screens expect as globals,
 * the admin stylesheet, and the behaviour shared by every admin page.
 *
 * Inline `@push('scripts')` blocks run after this bundle, so `$`, `bootstrap`
 * and `Parsley` are available to them.
 */
import './admin/jquery-global.js';
import * as bootstrap from 'bootstrap';
import 'parsleyjs';
import 'select2';

import 'bootstrap-icons/font/bootstrap-icons.css';
import 'select2/dist/css/select2.min.css';
import 'select2-bootstrap-5-theme/dist/select2-bootstrap-5-theme.min.css';
import '../sass/admin.scss';

window.bootstrap = bootstrap;

window.Parsley.addValidator('dateAfter', {
    requirementType: 'string',
    validateString: function (value, requirement) {
        const other = document.querySelector(requirement);
        if (!other || !other.value || !value) {
            return true;
        }
        return new Date(value) > new Date(other.value);
    },
});

// Contract period helpers
window.contractPeriod = {
    lengthInYears: 2,
    toDateString(date) {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        return yyyy + '-' + mm + '-' + dd;
    },
    defaultStartDate() {
        return this.toDateString(new Date());
    },
    endDateFrom(startDate) {
        const [year, month, day] = startDate.split('-').map(Number);
        const date = new Date(year, month - 1, day);
        date.setFullYear(date.getFullYear() + this.lengthInYears);
        date.setDate(date.getDate() - 1);
        return this.toDateString(date);
    },
    /**
     * The end date is filled in only for the plans that run for a fixed period,
     * i.e. every plan whose access expires.
     *
     * @param {jQuery} $startDate
     * @param {jQuery} $endDate
     * @param {boolean} hasNoExpiration
     * @param {boolean} overwrite
     */
    fillEndDate($startDate, $endDate, hasNoExpiration, overwrite) {
        if (hasNoExpiration || !$startDate.val()) {
            return;
        }
        if (!overwrite && $endDate.val()) {
            return;
        }

        $endDate.val(this.endDateFrom($startDate.val()));
    },
};

$(document).ready(function () {
    $('.js-select2').select2({
        theme: 'bootstrap-5',
    });

    // Off-canvas sidebar toggle, shown below the `lg` breakpoint in `layouts.admin.main`.
    $('.js-sidebar-toggle').on('click', function () {
        $('.js-sidebar').toggleClass('show');
    });

    document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => new bootstrap.Tooltip(el, { html: true }));
});
